<template>
  <div v-show="isConfirmedOrderList" id="confirmed_order_table">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- ステータスモーダル -->
    <dd-plan-status-modal
      ref="planStatusRef"
      :isConfirmedOrderList="isConfirmedOrderList"
      :checkedPlans="checkedPlans"
      @getConfirmedOrderList="getConfirmedOrderList"
    />
    <!-- 絞り込み検索モーダル -->
    <dd-plan-search-modal
      ref="planSearchRef"
      :isConfirmedOrderList="isConfirmedOrderList"
      @onClickSearch="onClickSearch"
    />
    <div class="table_wrapper">
      <!--  タイトルエリア  -->
      <div class="title_area">
        <h3>受注管理 → 生産計画</h3>
      </div>
      <div class="form_area">
        <div class="button_area">
          <button class="main_btn" @click="openStatusModal">変更処理</button>
          <button class="main_btn" @click="openSearchModal">絞り込み条件選択</button>
          <button class="main_btn" @click="downLoadCsv">CSV出力</button>
        </div>
        <!-- ページ -->
        <div>
          <dd-pager
            ref="pagerRef"
            :pageNo="pageNo"
            :dataCountPerPage="dataCount"
            :totalDataCount="totalCount"
            @paging="paging"
          />
        </div>
        <div class="disp_btn" @click="openDispModal">
          <div class="disp_icon">
            <span class="displogo"></span>
            <span class="displogo"></span>
            <span class="displogo"></span>
          </div>
          <div class="disptitle">表示項目</div>
        </div>
      </div>
      <!-- データテーブル -->
      <div class="plan_list_area">
        <table>
          <thead>
            <tr>
            <tr>
              <th class="check_area"><input type="checkbox" v-model="isCheckedAllPlans"></th>
              <th class="check_area">出力</th>
              <th :class="{none: checkDisp(0)}">計画ID</th>
              <th class="check_area" :class="{none: checkDisp(1)}">ステータス</th>
              <th class="check_area" :class="{none: checkDisp(2)}">サービス名</th>
              <th :class="{none: checkDisp(3)}">確定納品日</th>
              <th :class="{none: checkDisp(4)}">納品希望日時</th>
              <th :class="{none: checkDisp(5)}">組立設置希望日１</th>
              <th :class="{none: checkDisp(6)}">組立設置希望日２</th>
              <th :class="{none: checkDisp(7)}">組立設置希望日３</th>
              <th :class="{none: checkDisp(8)}">プランID</th>
              <th :class="{none: checkDisp(9)}">プラン名</th>
              <th :class="{none: checkDisp(10)}">物件名</th>
              <th :class="{none: checkDisp(11)}">発注会社名</th>
              <th :class="{none: checkDisp(12)}">発注者名</th>
              <th :class="{none: checkDisp(13)}">発注者ID</th>
              <th :class="{none: checkDisp(14)}">コンバイン個数</th>
              <th :class="{none: checkDisp(15)}">ユニット個数</th>
              <th :class="{none: checkDisp(16)}">注文番号</th>
              <th :class="{none: checkDisp(17)}">注文個別番号</th>
              <th :class="{none: checkDisp(18)}">営業コメント</th>
              <th :class="{none: checkDisp(19)}">受注特記事項</th>
              <th :class="{none: checkDisp(20)}">金額</th>
              <th :class="{none: checkDisp(21)}">商品代金</th>
              <th :class="{none: checkDisp(22)}">単価</th>
              <th class="ex_border" :class="{none: checkDisp(23)}">配送料</th>
              <th :class="{none: checkDisp(24)}">納品先名</th>
              <th :class="{none: checkDisp(25)}">郵便番号</th>
              <th :class="{none: checkDisp(26)}">納品先住所</th>
              <th :class="{none: checkDisp(27)}">受取人氏名</th>
              <th :class="{none: checkDisp(28)}">受取人電話番号</th>
              <th class="ex_border" :class="{none: checkDisp(29)}">配送時の連絡事項</th>
              <th v-for="(num, index) in 10" :key="index" :class="{none: checkDisp(30 + index)}">{{ customNameList[num-1] }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(plan, index) in dispPlanDataList"
              :key="index"
            >
              <td class="check_area">
                <input type="checkbox" v-if="isManufacturePlan(plan.planStatus)" :value="plan" v-model="checkedPlans">
              </td>
              <td class="check_area"><button class="list_btn gray_btn" @click="openPreview(plan.spaceJoincd)"></button></td>
              <td :class="{none: checkDisp(0)}">{{ plan.planRotCode }}</td>
              <td class="check_area" :class="{none: checkDisp(1)}">{{ plan.planStatusLabel }}</td>
              <td class="check_area" :class="{none: checkDisp(2)}">{{ getServiceType(plan.serviceType) }}</td>
              <td :class="{none: checkDisp(3)}">{{ getFormatSimpleDate(plan.planDeliveryDate) }}</td>
              <td :class="{none: checkDisp(4)}">{{ getDateAndTime(plan.ecInfoDeliPref1, plan.ecInfoDeliPref1StTime, plan.ecInfoDeliPref1EndTime) }}</td>
              <td :class="{none: checkDisp(5)}">{{ getFormatSimpleDate(plan.ecInfoBtPref1) }}</td>
              <td :class="{none: checkDisp(6)}">{{ getFormatSimpleDate(plan.ecInfoBtPref2) }}</td>
              <td :class="{none: checkDisp(7)}">{{ getFormatSimpleDate(plan.ecInfoBtPref3) }}</td>
              <td :class="{none: checkDisp(8)}">{{ plan.umPlanid }}</td>
              <td :class="{none: checkDisp(9)}">{{ plan.fileName }}</td>
              <td :class="{none: checkDisp(10)}">{{ plan.planPropertyName }}</td>
              <td :class="{none: checkDisp(11)}">{{ plan.ecSnapCorpName }}</td>
              <td :class="{none: checkDisp(12)}">{{ plan.ecSnapPerson }}</td>
              <td :class="{none: checkDisp(13)}">{{ plan.ecSnapUserId }}</td>
              <td class="number_area" :class="{none: checkDisp(14)}">{{ plan.combCount }}</td>
              <td class="number_area" :class="{none: checkDisp(15)}">{{ plan.unitCount}}</td>
              <td :class="{none: checkDisp(16)}">{{ plan.ecOrderNo }}</td>
              <td :class="{none: checkDisp(17)}">
                <span v-if="chkServiceType(plan.serviceType)" @click="goOrderDetail(plan.planOrderCode)"><a>{{ plan.planOrderCode }}</a></span>
                <span v-else>{{ plan.planOrderCode }}</span>
              </td>
              <td :class="{none: checkDisp(18)}">{{ plan.planSalesComment }}</td>
              <td :class="{none: checkDisp(19)}">{{ plan.planOrderComment }}</td>
              <td class="number_area" :class="{none: checkDisp(20)}">{{ plan.priceSales.toLocaleString() }}</td>
              <td class="number_area" :class="{none: checkDisp(21)}">{{ plan.priceProduct.toLocaleString() }}</td>
              <td class="number_area" :class="{none: checkDisp(22)}">{{ plan.priceUnit.toLocaleString() }}</td>
              <td class="ex_border" :class="{none: checkDisp(23)}">{{ plan.priceDelivery.toLocaleString() }}</td>
              <td :class="{none: checkDisp(24)}">{{ plan.planDeliveryName }}</td>
              <td :class="{none: checkDisp(25)}">{{ plan.planDeliveryPostcd }}</td>
              <td :class="{none: checkDisp(26)}">{{ plan.planDeliveryAddress }}</td>
              <td :class="{none: checkDisp(27)}">{{ plan.planDeliveryPerson }}</td>
              <td :class="{none: checkDisp(28)}">{{ plan.planDeliveryTel }}</td>
              <td class="ex_border" :class="{none: checkDisp(29)}">{{ plan.planDeliverryNotice }}</td>
              <td :class="{none: checkDisp(30)}">{{ plan.planCustom1 }}</td>
              <td :class="{none: checkDisp(31)}">{{ plan.planCustom2 }}</td>
              <td :class="{none: checkDisp(32)}">{{ plan.planCustom3 }}</td>
              <td :class="{none: checkDisp(33)}">{{ plan.planCustom4 }}</td>
              <td :class="{none: checkDisp(34)}">{{ plan.planCustom5 }}</td>
              <td :class="{none: checkDisp(35)}">{{ plan.planCustom6 }}</td>
              <td :class="{none: checkDisp(36)}">{{ plan.planCustom7 }}</td>
              <td :class="{none: checkDisp(37)}">{{ plan.planCustom8 }}</td>
              <td :class="{none: checkDisp(38)}">{{ plan.planCustom9 }}</td>
              <td :class="{none: checkDisp(39)}">{{ plan.planCustom10 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import encoding from 'encoding-japanese'
import {API_URL, STORAGE_KEY} from '../../constants/App'
import {PLAN_STATUS, LIST_TYPE, SERVICE_TYPE} from '../../constants/Type'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import PlanOrderStatusModal from '../list/modal/PlanOrderStatusModal'
import PlanSearchModal from '../list/modal/PlanSearchModal'
import ListDispModal from '../list/modal/ListDispModal'
import LoadingModal from '../common/LoadingModal'
import Pager from '../../components/common/OrderPager'

export default {
  name: 'ConfirmedOrderTable',
  components: {
    'dd-plan-status-modal': PlanOrderStatusModal,
    'dd-plan-search-modal': PlanSearchModal,
    'dd-plan-disp-modal': ListDispModal,
    'dd-pager': Pager,
    'dd-loading-modal': LoadingModal
  },
  props: {
    isConfirmedOrderList: Boolean,
    customNameList: Array,
    dispForm: Object
  },
  data () {
    return {
      /** ページ番号 */
      pageNo: 1,
      /** 1ページごとの表示件数 */
      dataCount: 14,
      /** 総件数 */
      totalCount: 0,
      /** プランリスト全件 */
      planDataList: [],
      /** 表示用プランリスト */
      dispPlanDataList: [],
      /** 全プランチェックフラグ */
      isCheckedAllPlans: false,
      /** チェックボックス選択中プラン */
      checkedPlans: [],
      /** 検索条件 */
      searchForm: {
        planStatus: [],
        estimateDateStart: '',
        estimateDateEnd: '',
        manufactureDateStart: '',
        manufactureDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        completeDateStart: '',
        completeDateEnd: '',
        planRotCode: '',
        umPlanid: '',
        fileName: '',
        pageNo: '',
        dataCount: ''
      },
      imgCheckMark: this.getImage('pages/list/ic_check.svg')
    }
  },
  watch: {
    /** 受注確定リスト表示フラグ */
    isConfirmedOrderList: function () {
      if (this.isConfirmedOrderList) {
        document.addEventListener('mouseup', this.onMouseup)
      } else {
        document.removeEventListener('mouseup', this.onMouseup)
      }
    },
    /** 一括チェック */
    isCheckedAllPlans: function () {
      if (this.isCheckedAllPlans) {
        this.checkedPlans = []
        this.dispPlanDataList
          .filter(plan => this.isManufacturePlan(plan.planStatus))
          .forEach(plan => {
            this.checkedPlans.push(plan)
          })
      } else {
        this.checkedPlans = []
      }
    }
  },
  methods: {
    /** 生産計画処理リストを取得・表示 */
    getConfirmedOrderList: function (isFirstView) {
      if (isFirstView) {
        this.pageNo = 1
        this.$refs.pagerRef.setCurrentPage(this.pageNo)
        this.clear()
      } else {
        this.searchForm = App.getLocalStorage(STORAGE_KEY.PLAN_SEARCH)
      }
      this.checkedPlans = []
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.onSearch(this.searchForm)
    },
    /** 残日を取得 */
    getRemainingDate: function (planOrderShipDate) {
      let shipDate = new Date(this.getFormatDate(planOrderShipDate))
      let remainingDate = this.getDiff(new Date(), shipDate) + 1
      if (!remainingDate) {
        return ''
      } else if (remainingDate < 0) {
        return 0
      }
      return remainingDate
    },
    /** 枝番を取得 */
    getIndex: function (id) {
      let index = id.indexOf('-')
      if (index < 0) {
        return ''
      }
      return id.slice(index + 1)
    },
    /** ステータスモーダルを開く */
    openStatusModal: function () {
      this.$refs.planStatusRef.showModal()
    },
    /** 絞り込み条件設定モーダルを開く */
    openSearchModal: function () {
      this.$refs.planSearchRef.showModal()
    },
    /** 表示項目切替モーダルを開く */
    openDispModal: function () {
      this.$emit('showDispModal')
    },
    /** 検索ボタン押下 */
    onClickSearch: function (searchForm) {
      this.pageNo = 1
      this.$refs.pagerRef.setCurrentPage(this.pageNo)
      searchForm.pageNo = this.pageNo
      searchForm.dataCount = this.dataCount
      this.onSearch(searchForm)
    },
    /** 絞り込み条件で検索 */
    onSearch: function (searchForm) {
      searchForm.planStatus = [PLAN_STATUS.ORDER_CONFIRMED.code, PLAN_STATUS.MANUFACTURE.code]
      App.setLocalStorage(STORAGE_KEY.PLAN_SEARCH, searchForm)
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.LIST + '/confirmed-order', searchForm)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.planDataList = response.data.data.columnDataList
          this.dispPlanDataList = this.planDataList
          this.totalCount = response.data.data.totalCount
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 項目の表示・非表示判定 */
    checkDisp: function (num) {
      return !this.dispForm.orderCheckList.includes(num)
    },
    /** 数字ボタンが押すたびに動く処理 */
    paging: function (pageNo) {
      this.pageNo = pageNo
      this.searchForm = App.getLocalStorage(STORAGE_KEY.PLAN_SEARCH)
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.onSearch(this.searchForm)
    },
    /** 出力プレビューの表示 */
    openPreview: function (joincd) {
      let childWindow = window.open('/#/preview?spaceJoincd=' + joincd, 'sheet-page', 'width=1420, height=940')
      childWindow.location.reload()
    },
    /** CSV出力 */
    downLoadCsv: function () {
      axios.get(API_URL.LIST + '/download/' + LIST_TYPE.ORDER.code)
        .then(response => {
          let formatStr = moment().format('YYYYMMDDHHmmss')
          let arrayData = response.data.data
          let csvData = arrayData.map(function (l) { return l.join(',') }).join('\r\n')
          // SJISに変換する
          let sjisArray = encoding.convert(encoding.stringToCode(csvData), {to: 'SJIS'})
          let blob = new Blob([new Uint8Array(sjisArray)], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'OrderList_' + formatStr + '.csv'
          link.click()
          let modalData = {
            messages: ['ファイルをダウンロードしました。']
          }
          App.showModal(modalData)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    clear: function () {
      this.searchForm = {
        planStatus: [],
        estimateDateStart: '',
        estimateDateEnd: '',
        orderDateStart: '',
        orderDateEnd: '',
        manufactureDateStart: '',
        manufactureDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        completeDateStart: '',
        completeDateEnd: '',
        planRotCode: '',
        umPlanid: '',
        businessName: '',
        fileName: '',
        pageNo: '',
        dataCount: ''
      }
    },
    /** 生産計画待ちプラン判定 */
    isManufacturePlan: function (status) {
      return status === PLAN_STATUS.ORDER_CONFIRMED.code
    },
    /** サービス名を取得 */
    getServiceType: function (num) {
      switch (num) {
        case SERVICE_TYPE.DAROS.code:
          return SERVICE_TYPE.DAROS.label
        case SERVICE_TYPE.MMSTYLE.code:
          return SERVICE_TYPE.MMSTYLE.label
        case SERVICE_TYPE.KAGULL.code:
          return SERVICE_TYPE.KAGULL.label
        case SERVICE_TYPE.YASUMOKU.code:
          return SERVICE_TYPE.YASUMOKU.label
        default:
          return ''
      }
    },
    chkServiceType: function (num) {
      if (num === SERVICE_TYPE.MMSTYLE.code) {
        return true
      } else {
        return false
      }
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    getFormatSimpleDate: function (date) {
      if (date) {
        return moment(date).format('M/DD')
      } else {
        return ''
      }
    },
    getDateAndTime: function (date, start, end) {
      if (!moment(date).isValid()) return ''
      let time = moment(date).format('YYYY/MM/DD')
      if (!start || !end) {
        time += ' 時間指定なし'
      } else {
        time += start < 12 ? ' AM ' : ' PM '
        time += start + ':00'
        time += '～'
        time += end + ':00'
      }
      return time
    },
    /** 日数差分を計算 */
    getDiff: function (date1Str, date2Str) {
      let date1 = new Date(date1Str)
      let date2 = new Date(date2Str)
      let msDiff = date2.getTime() - date1.getTime()
      let daysDiff = Math.floor(msDiff / (1000 * 60 * 60 * 24))
      return ++daysDiff
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    },
    goOrderDetail: function (orderCode) {
      this.$router.push({
        name: 'OrderDetail',
        query: {id: orderCode}
      })
    }
  },
  mounted: function () {
    this.processingDate = this.getFormatDate(new Date())
  },
  beforeDestroy: function () {
    document.removeEventListener('mouseup', this.onMouseup)
  }
}
</script>

<style src="../../css/list/list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#confirmed_order_table {
  height: 95%;
  width: 95%;
    padding: 10px 30px;
}
.title_area {
  color: #2F5496;
  background-color: #D6DCE4
}
table {
  td {
    a {
      color: blue;
    }
    a:hover {
      color: #ff4500;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/ConfirmedOrderTable.vue